import React from 'react';
import * as Yup from 'yup';
import { Row, Column } from '../../shared/components/Grid/Grid';
import { Button } from '@economic/gaudi';
import { Form, Field } from '../../shared/components/Form';
import { FormProps } from '../types';
import AccessDropdown from '../../shared/components/ui/AccessDropdown';
import internalApiClient from '../../shared/util/api/internalApiClient';
import { t } from '../../shared/components/l10n/l10n';
import { Department } from '../../views/Departments';

const initialValues: Partial<Department> = {
    access: true,
    number: undefined,
    name: undefined,
    isDepartment: true,
};

const validationSchema = Yup.object({
    access: Yup.boolean().required(),
    number: Yup.number().required(),
    name: Yup.string().required(),
    isDepartment: Yup.boolean().required(),
});

export default function CreateDepartmentForm({
    initialData = initialValues,
    notifications,
    onSubmitted,
    onSubmitError,
    onCancel,
}: FormProps<Department>) {
    const handleSubmit = async values => {
        try {
            const response = await internalApiClient.post(`/departments`, values);
            return Promise.resolve(response);
        } catch (error) {
            error.validation = error.response.data;
            return Promise.reject(error);
        }
    };

    return (
        <Form
            initialData={{ ...initialData, isDepartment: true }}
            messages={notifications}
            onSubmit={handleSubmit}
            onSubmitted={onSubmitted}
            onSubmitError={onSubmitError}
            validationSchema={validationSchema}>
            <h1>{t`FORM_DEPARTMENT_CREATETEXT`}</h1>

            <Row>
                <Column xs="8">
                    <Field.Number label={t`FORM_FIELD_LABEL_NUMBER`} name="number" required />
                    <Field.Text label={t`FORM_FIELD_LABEL_NAME`} name="name" required />
                    <Field.Dropdown label={t`FORM_FIELD_LABEL_ACCESS`} name="access" as={AccessDropdown} />
                </Column>
            </Row>

            <div className="form__buttons">
                <Button type="submit" appearance="primary">{t`BUTTON_SAVE`}</Button>
                {onCancel && (
                    <Button onClick={onCancel} appearance="default">
                        {t`BUTTON_CANCEL`}
                    </Button>
                )}
            </div>
        </Form>
    );
}
